// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DriverLeadAPIModel from "../api-model/DriverLeadAPIModel.bs.js";
import * as Timestamp$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function getDriverInfo(res) {
  return {
          mobile: res.mobile,
          name: res.name,
          city: res.city.name
        };
}

function getBasicInfo(res) {
  return {
          city_name: res.city.name
        };
}

function getVehicleInfo(res) {
  return {
          number: res.number,
          vehicle_type: res.category.vehicleType,
          model: res.category.displayName,
          body_type: res.bodyType
        };
}

function getStatusInfo(res) {
  return {
          status: res.status,
          is_waitlisted: res.waitlistInfo.isWaitlisted,
          waitlist_reason: res.waitlistInfo.waitlistReason,
          waitlisted_at: Timestamp$Catalyst.make(Belt_Option.getWithDefault(res.waitlistInfo.waitlistedAt, Date.now())),
          last_updated_at: Timestamp$Catalyst.make(res.lastUpdatedAt)
        };
}

function getOwnerInfo(res) {
  return {
          mobile: res.mobile,
          name: res.name
        };
}

function apiModelToState(res) {
  return {
          data: List.map((function (model) {
                  return {
                          lead_id: model.externalId,
                          basic_info: {
                            city_name: model.basicInfo.city.name
                          },
                          driver_info: getDriverInfo(model.basicInfo),
                          owner_info: getOwnerInfo(model.ownerInfo),
                          vehicle_info: getVehicleInfo(model.vehicleInfo),
                          status_info: getStatusInfo(model.statusInfo)
                        };
                }), res)
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(DriverLeadAPIModel.t_decode(json), "DriverLeadEntityMapper.res"));
}

export {
  getDriverInfo ,
  getBasicInfo ,
  getVehicleInfo ,
  getStatusInfo ,
  getOwnerInfo ,
  apiModelToState ,
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
